import React from 'react';
import { connect } from "react-redux";

import _ from "lodash";

import Cell from '../components/cell';
import Timeseries from '../components/timeseries';
import EntityReport from '../components/reports';
import DiscoveryMatrixReport from '../components/discoveryMatrix';
import { ReportContext } from '../view';

import { Asset, User, UserGroup, Search, Collection, Sharer } from '../components/entities';

import {
  STREAM, ASSET,
  COLLECTION, USER, USER_GROUP,
  CONTACT
} from "../../../constants/entities"

import styles from '../reports.module.scss';
import { localizedStrings } from '../../../../localization/index';
import userRoleService from "src/services/userRoles.service";
import { resetReportDownload } from 'src/legacy/redux/actions/reports';

const mapDispatchToProps = (dispatch) => {
  return {
    resetReportDownload: () => dispatch(resetReportDownload()),
  };
};

class DiscoveryReportView extends React.Component {

  constructor(props) {
    super(props);

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedDiscovery = this.localizedReport.tabs.discovery;
    this.localizedHeaders = this.localizedReport.tabs.commons.headers;

  }

  componentDidMount() {
    this.props.trackAdoptionMetricsForReportsToggledViewEvent('Discovery');
  }

  render() {
    const localizedDiscovery = this.localizedReport.tabs.discovery;
    return (
      <ReportContext.Consumer>
        {( contextObj ) => (
      <div className={styles.grid}>
        <Cell column={2}>
          <AssetViewReport request={contextObj.filter} fetchData={(request) => {
            this.props.fetchDiscoveryAssetViewsGraphReport(request);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
        <Cell>
          <DiscoveryMatrixReport request={contextObj.filter} 
            downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
            download = {this.props.download}
            tooltipText = {localizedDiscovery.tooltip_texts.content_discovery_matrix}
          />
        </Cell>

        <Cell>
          <AssetReport request={contextObj.filter} fetchData={(request) => {
            this.props.fetchDiscoveryAssetsGraphReport(request);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
        {userRoleService.canAccessCollection() &&
          <Cell>
            <CollectionReport request={contextObj.filter} fetchData={(request) => {
              this.props.fetchDiscoveryCollectionActivityGraphReport(request);
            }}
              downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
              download={this.props.download}
            />
          </Cell>
        }

        {userRoleService.canShare() &&
          <Cell>
            <ConversationReport request={contextObj.filter} fetchData={(request) => {
              this.props.fetchDiscoveryShareGraphReport(request);
            }}
              downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
              download={this.props.download}
            />
          </Cell>
        }

        <Cell>
          <PopularAssetsReport request={contextObj.filter} fetchData={(request, page, limit) => {
            this.props.fetchDiscoveryPopularAssets(request, page, limit);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
        <Cell>
          <TopUsersReport request={contextObj.filter} fetchData={(request, page, limit) => {
            this.props.fetchDiscoveryTopUsers(request, page, limit);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
        {userRoleService.canShare() &&
          <Cell>
            <TopSharersReport request={contextObj.filter} fetchData={(request, page, limit) => {
              this.props.fetchDiscoveryTopSharers(request, page, limit);
            }}
              downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
              download={this.props.download}
            />
          </Cell>
        }
        <Cell>
          <TopUserGroupsReport request={contextObj.filter} fetchData={(request, page, limit) => {
            this.props.fetchDiscoveryTopUserGroups(request, page, limit);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
        {userRoleService.canAccessCollection() &&
          <Cell>
            <CollectionsCreatedReport request={contextObj.filter} fetchData={(request, page, limit) => {
              this.props.fetchDiscoveryCollections(request, page, limit);
            }}
              downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
              download={this.props.download}
            />
          </Cell>
        }
        {userRoleService.canAccessCollection() && userRoleService.canShare() &&
          <Cell>
            <CollectionsSharedReport request={contextObj.filter} fetchData={(request, page, limit) => {
              this.props.fetchDiscoveryCollectionsShared(request, page, limit);
            }}
              downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
              download={this.props.download}
            />
          </Cell>
        }
        {userRoleService.canShare() &&
          <Cell>
            <AssetsSharedReport request={contextObj.filter} fetchData={(request, page, limit) => {
              this.props.fetchDiscoveryAssetsShared(request, page, limit);
            }}
              downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
              download={this.props.download}
            />
          </Cell>
        }
        <Cell>
          <TopSearchQueriesReport request={contextObj.filter} fetchData={(request, page, limit) => {
            this.props.fetchDiscoverySearchQueries(request, page, limit);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
        <Cell>
          <TopTagsReport request={contextObj.filter} fetchData={(request, page, limit) => {
            this.props.fetchDiscoverySearchTags(request, page, limit);
          }} 
          downloadReport = {(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
          download = {this.props.download}
          />
        </Cell>
      </div>)}
      </ReportContext.Consumer>
    );
  }
}

const AssetViewReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.discovery.assetViewsGraph.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedDiscovery.asset_views} (${count})`,
      loading: state.legacyRootReducer.reports.discovery.assetViewsGraph.loading,
      data: state.legacyRootReducer.reports.discovery.assetViewsGraph.item,
      supportedEntities: [ASSET, STREAM, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.asset_views
      }, tooltipText: localizedDiscovery.tooltip_texts.asset_views
     

    };
  }
)(Timeseries);

const AssetReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.discovery.assetsGraph.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;
    const localizedKeywords = localizedStrings.keywords;

    return {
      title: `${localizedDiscovery.assets} (${count})`,
      loading: state.legacyRootReducer.reports.discovery.assetsGraph.loading,
      data: state.legacyRootReducer.reports.discovery.assetsGraph.item,
      supportedEntities: [STREAM, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedKeywords.assets
      },
      tooltipText: localizedDiscovery.tooltip_texts.assets
    };
  }
)(Timeseries);

const CollectionReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.discovery.collectionActivityGraph.item, (day) => day.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;
    const localizedKeywords = localizedStrings.keywords;

    return {
      title: `${localizedDiscovery.collection_activity} (${count})`,
      loading: state.legacyRootReducer.reports.discovery.collectionActivityGraph.loading,
      data: state.legacyRootReducer.reports.discovery.collectionActivityGraph.item,
      supportedEntities: [ASSET, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedKeywords.collections
      },
      tooltipText: localizedDiscovery.tooltip_texts.collection_activity
    };
  }
)(Timeseries);

const ConversationReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.discovery.sharesGraph.item, (day) => day.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedDiscovery.conversation_activity} (${count})`,
      loading: state.legacyRootReducer.reports.discovery.sharesGraph.loading,
      data: state.legacyRootReducer.reports.discovery.sharesGraph.item,
      supportedEntities: [ASSET, COLLECTION, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.shares
      },
      tooltipText: localizedDiscovery.tooltip_texts.conversation_activity
    };
  }
)(Timeseries);

//List Reports
const PopularAssetsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.popularAssets, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_assets",
      title: `${localizedDiscovery.popular_with_team} (${count})`,
      list: {
        renderer: Asset.List
      },
      grid: {
        renderer: Asset.Grid,
        columns: [{
          title: '',
          width: 7
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.shares,
          width: 1
        }]
      },
      supportedEntities: [ASSET, STREAM, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.popularAssets,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.asset_name], [localizedHeaders.created_date], [localizedHeaders.author], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.shares],[localizedHeaders.file_type]],
        fileName: "DiscoveryPopularAssets.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.popular_with_team,
    }
  }, mapDispatchToProps
)(EntityReport); 

const TopUsersReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.topUsers, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_users",
      title: `${localizedDiscovery.top_users} (${count})`,
      
      list: {
        renderer: User.List
      },
      grid: {
        renderer: User.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.shares,
          width: 2
        }]
      },
      supportedEntities: [ASSET, STREAM, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.topUsers,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.user_name], [localizedHeaders.joined_date], [localizedHeaders.role], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.shares], [localizedHeaders.last_active]],
        fileName: "DiscoveryTopUsers.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.top_users
    }
  },
  mapDispatchToProps
)(EntityReport);

const TopSharersReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.topSharers, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_sharers",
      title: `${localizedDiscovery.top_shares} (${count})`,
      
      list: {
        renderer: Sharer.List
      },
      grid: {
        renderer: Sharer.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.counts.shares,
          width: 2
        }, {
          title: localizedHeaders.counts.assets,
          width: 2
        }, {
          title: localizedHeaders.counts.recipients,
          width: 2
        }]
      },
      supportedEntities: [ASSET, STREAM, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.topSharers,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.email], [localizedHeaders.joined_date], [localizedHeaders.shares], [localizedHeaders.assets], [localizedHeaders.recipients], [localizedHeaders.last_active]],
        fileName: "DiscoveryTopShares.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.top_sharers
    }
  },
  mapDispatchToProps
)(EntityReport);

const TopUserGroupsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.topUserGroups, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_user_groups",
      title: `${localizedDiscovery.top_user_groups} (${count})`,
      
      list: {
        renderer: UserGroup.List
      },
      grid: {
        renderer: UserGroup.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title:  localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.shares,
          width: 2
        }]
      },
      supportedEntities: [ASSET, STREAM, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.topUserGroups,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.group_name], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.shares], [localizedHeaders.users]],
        fileName: "DiscoveryTopUserGroups.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.top_user_groups
    }
  },
  mapDispatchToProps
)(EntityReport);

const TopSearchQueriesReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.searchQueries, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_search_queries",
      title: `${localizedDiscovery.most_searched_query} (${count})`,
      
      className: styles.search,
      list: {
        renderer: Search.List
      },
      grid: {
        renderer: Search.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.searches,
          width: 2
        }, {
          title: '',
          width: 4
        }, {
          title: localizedHeaders.searches,
          width: 2
        }]
      },
      supportedEntities: [USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.searchQueries,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.query], [localizedHeaders.search_count]],
        fileName: "DiscoverySearchQueries.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.most_searched_query
    }
  },
  mapDispatchToProps
)(EntityReport);

const TopTagsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.searchTags, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_search_tags",
      title: `${localizedDiscovery.most_used_query} (${count})`,
      
      className: styles.search,
      list: {
        renderer: Search.Tag.List
      },
      grid: {
        renderer: Search.Tag.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.counts.assets,
          width: 1
        }, {
          title: localizedHeaders.counts.searches,
          width: 1
        }, {
          title: '',
          width: 4
        }, {
          title: localizedHeaders.counts.assets,
          width: 1
        }, {
          title: localizedHeaders.counts.searches,
          width: 1
        }]
      },
      supportedEntities: [STREAM, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.searchTags,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.asset_count], [localizedHeaders.search_count]],
        fileName: "DiscoveryTopTags.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.most_used_tags
    }
  },
  mapDispatchToProps
)(EntityReport);


const CollectionsCreatedReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.collectionsCreated, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_collections",
      title: `${localizedDiscovery.collection_created} (${count})`,
      
      list: {
        renderer: Collection.List
      },
      grid: {
        renderer: Collection.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.created_by,
          width: 2
        }, {
          title: localizedHeaders.created_on,
          width: 2
        }, {
          title: localizedHeaders.last_updated,
          width: 2
        }, {
          title: localizedHeaders.shares,
          width: 1
        }, {
          title: localizedHeaders.views,
          width: 1
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET],
      data: state.legacyRootReducer.reports.discovery.collectionsCreated,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.created_by], [localizedHeaders.created_on], [localizedHeaders.last_updated], [localizedHeaders.assets], [localizedHeaders.views], [localizedHeaders.shares]],
        fileName: "DiscoveryCollections.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.collection_created
    }
  }, 
  mapDispatchToProps
)(EntityReport);

const CollectionsSharedReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.collectionsShared, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_collections_shared",
      title: `${localizedDiscovery.collection_shared} (${count})`,
      
      list: {
        renderer: Collection.List
      },
      grid: {
        renderer: Collection.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.created_by,
          width: 2
        }, {
          title: localizedHeaders.created_on,
          width: 2
        }, {
          title: localizedHeaders.last_updated,
          width: 2
        }, {
          title: localizedHeaders.shares,
          width: 1
        }, {
          title: localizedHeaders.views,
          width: 1
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION],
      data: state.legacyRootReducer.reports.discovery.collectionsShared,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.created_by], [localizedHeaders.created_on], [localizedHeaders.last_updated], [localizedHeaders.assets], [localizedHeaders.views], [localizedHeaders.shares]],
        fileName: "DiscoveryCollectionsShared.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.collection_shared
    }
  },
  mapDispatchToProps
)(EntityReport);

const AssetsSharedReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.discovery.assetsShared, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedDiscovery = localizedReport.tabs.discovery;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "discovery_assets_shared",
      title: `${localizedDiscovery.frequently_shared_assets} (${count})`,
      
      list: {
        renderer: Asset.Share.List
      },
      grid: {
        renderer: Asset.Share.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.author,
          width: 2,
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.downloads,
          width: 1
        }, {
          title: localizedHeaders.counts.shares,
          width: 1
        }]
      },
      supportedEntities: [ASSET, STREAM, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.discovery.assetsShared,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.asset_name], [localizedHeaders.created_date], [localizedHeaders.author], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.downloads], [localizedHeaders.shares]],
        fileName: "DiscoveryAssetsShared.csv"
      },
      tooltipText: localizedDiscovery.tooltip_texts.frequently_shared_assets
    }
  },
  mapDispatchToProps
)(EntityReport);

export default DiscoveryReportView;